import HttpRequest from '@/config/axios.config'
import { getUrlParamsFromObject } from '../TaskTable/TaskTable.helper'

const encodeString = (char: string) => char.replace('/', '%2F')

export async function getStyleIdsByFilter(params: any) {
  return await HttpRequest.get(`/properties/field/style_ids`, {
    params,
  })
}
export const getTasks = (ids: {
  key: string
  properties: string[]
  orders: string[]
}) => {
  return HttpRequest.post(`sections/orders/multiple`, ids)
}

export const getOrderCount = (
  taskName: string,
  sectionName: string,
  orderIds: string[]
) => {
  return HttpRequest.post(
    `tasks/${encodeString(taskName)}/sections/${encodeString(
      sectionName
    )}/order-count`,
    { order_ids: orderIds }
  )
}

export const getOrder = (params: { [key: string]: any }) => {
  const urlParams = getUrlParamsFromObject(params)
  return HttpRequest.get(`/orders?${urlParams}`)
}

export const getGroupOrders = (params: {
  page_number: number
  page_size: number
  value: string
  data_type: string
  group: string
  status: string
}) => {
  const urlParams = getUrlParamsFromObject(params)
  return HttpRequest.get(`/orders/group?${urlParams}`)
}

export const massUpdateTask = (payload: {
  order_ids: string[]
  section_name: string
  task_name: string
  plan_date?: string
  current_status?: string
  comment?: string
  medias?: {
    external_reference: string
    table: string
    name: string
    url_path: string
    type: string
    size: number
  }[]
}) => {
  return HttpRequest.put(`tasks/mass-update`, payload)
}
